export default (host: string) => ({
  '@id': 'organization',
  'address': {
    '@type': 'PostalAddress',
    'addressCountry': 'CH',
    'addressLocality': 'Stabio',
    'addressRegion': 'Ticino',
    'postalCode': '6855',
    'streetAddress': 'Via Laveggio 5'
  },
  'areaServed': 'DK',
  'brand': {
    '@type': 'Brand',
    '@id': `https://${host}/da-dk#brand`,
    'name': 'Timberland',
    'description': 'Timberland er skabt til de modige. Vi inspirerer og udstyrer eventyrere til at komme ud, arbejde hårdt og flytte verden fremad.',
    'url': `https://${host}/da-dk`,
    'image': `https://${host}/img/logo50.svg`
  },
  'contactPoint': [
    {
      '@type': 'ContactPoint',
      'telephone': '+45 80252978',
      'contactType': 'Telephone',
      'areaServed': 'DK',
      'hoursAvailable': 'Ma, Ti, On, To, Fr 09:00-19:00 CET'
    },
    {
      '@type': 'ContactPoint',
      'contactType': 'Chat',
      'areaServed': 'DK',
      'hoursAvailable': 'Ma, Ti, On, To, Fr 09:00-19:00 CET',
      'url': `https://${host}/da-dk`
    }
  ],
  'logo': {
    '@id': '#logo',
    'caption': 'Timberland',
    'contentUrl': `https://${host}/img/logo50.svg`,
    'url': `https://${host}/img/logo50.svg`
  },
  'name': 'Timberland',
  'parentOrganization': 'VF Corporation (VFC)',
  'sameAs': [
    'https://www.youtube.com/timberland',
    'https://www.instagram.com/timberland',
    'https://www.facebook.com/timberland'
  ],
  'url': `https://${host}/da-dk`
})
